import React, { useState } from 'react';
import RingRatioBubble from '@/pages/opinion/components/Snippets/RingRatioBubble';
import PercentageItem from '@/pages/opinion/components/Snippets/PercentageItem';

import {
  percentageFormat,
  reviewsFormat,
  scoreFormat,
  sentimentFormat,
} from '@/pages/opinion/utils/value';
import './index.scss';
import LineCharts from './LineCharts';
import { useIntl } from 'umi';
import { formatDateFunc } from '@/pages/opinion/utils/time';

export default function RatingItem({
  score,
  newScore,
  oldScore,
  newTime,
  oldTime,
  flag,
  filterSelected,
  reviews,
  rationPercent,
  timeLine,
  isSelected = false,
  noData = true,
  dateType,
  reviewClick,
  valueFormat = scoreFormat,
  windowValueFormat = sentimentFormat,
  title = 'User Score',
  isMax = false,
  isGlobal = false,
}: any) {
  const [mouseEnter, setMouseEnter] = useState(false);
  const { formatMessage } = useIntl();
  const formatTime = formatDateFunc(dateType);
  return (
    <>
      <div
        className={`dbo-regioncountry-item ${
          (isSelected && flag) || filterSelected ? 'is-selected' : ''
        } ${isMax ? 'dbo-max-text-info' : ''}`}
        onMouseEnter={() => {
          setMouseEnter(true);
        }}
        onMouseLeave={() => {
          setMouseEnter(false);
        }}
      >
        {mouseEnter ? (
          <div
            className="regioncountry-item-more"
            onClick={() => reviewClick?.()}
          >
            {formatMessage({ id: 'Go to Reviews' })}
          </div>
        ) : null}

        <RingRatioBubble
          oldTime={oldTime}
          newTime={newTime}
          oldValue={oldScore}
          newValue={newScore}
          showContent={!noData}
          formateDate={formatTime}
          formateValue={windowValueFormat}
          otherInfo={
            <>
              <div className="regioncountry-bubble-line">
                <span className="regioncountry-bubble-tit">
                  {formatMessage({ id: 'Reviews' })}
                </span>
                <div className="regioncountry-bubble-text">
                  {reviewsFormat(reviews)}
                </div>
              </div>
              <div className="regioncountry-bubble-line">
                <span className="regioncountry-bubble-tit">
                  {formatMessage({ id: title + ' Change%' })}
                </span>
                <div className="regioncountry-bubble-text">
                  {percentageFormat(rationPercent)}
                </div>
              </div>
            </>
          }
        >
          <div className="regioncountry-item-info">
            <div className="regioncountry-item-score">
              <div
                className={`regioncountry-item-score-num ${
                  isMax ? 'dbo-max-item-num' : ''
                }`}
              >
                {valueFormat(score)}
              </div>
              <PercentageItem percentage={rationPercent}></PercentageItem>
            </div>
            <div className="regioncountry-item-des">
              {reviewsFormat(reviews)}
            </div>
          </div>
        </RingRatioBubble>

        <div
          className={`regioncountry-item-charts ${
            isMax ? 'dbo-max-charts' : ''
          }`}
        >
          <LineCharts
            title={title}
            scoreValueFormat={valueFormat}
            timeLine={timeLine}
            dateType={dateType}
          ></LineCharts>
        </div>
      </div>
    </>
  );
}
